import { render, staticRenderFns } from "./bindCode.vue?vue&type=template&id=4d743620&scoped=true&"
import script from "./bindCode.vue?vue&type=script&lang=js&"
export * from "./bindCode.vue?vue&type=script&lang=js&"
import style0 from "./bindCode.vue?vue&type=style&index=0&id=4d743620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d743620",
  null
  
)

export default component.exports